import React from 'react';
import { PartnerCacheProvider } from './PartnerCacheContext';
import { UnitMeasurementCacheProvider } from './UnitMeasurementCacheContext';
import { ItemCacheProvider } from './ItemCacheContext';
import { IngredientCacheProvider } from './IngredientCacheContext';
import { ClassificationCacheProvider } from './ClassificationCacheContext';
import { WarehouseCacheProvider } from './WarehouseCacheContext';

interface CombinedCacheProviderProps {
  children: React.ReactNode;
}

/**
 * Combined provider that wraps all cache providers to reduce nesting in App.tsx
 * This improves code readability and maintainability
 */
export const CombinedCacheProvider: React.FC<CombinedCacheProviderProps> = ({ children }) => {
  return (
    <PartnerCacheProvider>
        <UnitMeasurementCacheProvider>
          <ItemCacheProvider>
            <IngredientCacheProvider>
              <ClassificationCacheProvider>
                <WarehouseCacheProvider>
                  {children}
                </WarehouseCacheProvider>
              </ClassificationCacheProvider>
            </IngredientCacheProvider>
          </ItemCacheProvider>
        </UnitMeasurementCacheProvider>
      </PartnerCacheProvider>
  );
};
